module.exports = __webpack_public_path__ + "img/A413_vue_pers.e92fef07.png";